import jadePic from "@/public/images/artists/jade.png";
import { Artist } from "@/types/types";

export const jade = {
  id: "164",
  name: "Jade",
  image: jadePic,
  description: `Jade's voice combines youthful, ethereal tones with soulful depth. With influences from R&B, electronic, and neo-soul, her vocals strike a balance between polished clarity and raw energy, blending lightness with vibrant, rhythmic movement.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjade-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Hip Hop", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 57,
        high: 72,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
